import { render, staticRenderFns } from "./InfoTableItem.vue?vue&type=template&id=d5d9aa22&scoped=true"
import script from "./InfoTableItem.vue?vue&type=script&lang=ts"
export * from "./InfoTableItem.vue?vue&type=script&lang=ts"
import style0 from "./InfoTableItem.vue?vue&type=style&index=0&id=d5d9aa22&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5d9aa22",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d5d9aa22')) {
      api.createRecord('d5d9aa22', component.options)
    } else {
      api.reload('d5d9aa22', component.options)
    }
    module.hot.accept("./InfoTableItem.vue?vue&type=template&id=d5d9aa22&scoped=true", function () {
      api.rerender('d5d9aa22', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Viewer/Info/InfoTableItem.vue"
export default component.exports